import { BaseSettingsLayout } from './BaseSettingsLayout';

const sidebarNavItems = [
  {
    title: 'General',
    href: '/team/settings',
  },
  {
    title: 'Members',
    href: '/team/members',
  },
  {
    title: 'Connections',
    href: '/team/connections',
  },
];

export const TeamSettingsLayout = () => {
  return (
    <BaseSettingsLayout
      title="Team Settings"
      sidebarNavItems={sidebarNavItems}
    />
  );
};
